export const fontSizes = [
  { name: '작게 (12px)', value: '12px' },
  { name: '보통 (14px)', value: '14px' },
  { name: '보통 (16px)', value: '16px' },
  { name: '크게 (18px)', value: '18px' },
  { name: '크게 (20px)', value: '20px' },
  { name: '더 크게 (24px)', value: '24px' },
  { name: '매우 크게 (32px)', value: '32px' },
  { name: '최대 (48px)', value: '48px' },
] as const;
